module.exports = __webpack_public_path__ + "fca426222d5a3d0efb8bc0976a29356a.png";